import React, { useEffect, useState, useRef } from 'react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    // Close mobile menu after navigation
    setIsMobileMenuOpen(false);
  };
  const navItems = [{
    label: 'How it works',
    id: 'how-it-works'
  }, {
    label: 'About',
    id: 'about'
  }, {
    label: 'Engagements',
    id: 'engagements'
  }, {
    label: 'Scope',
    id: 'scope'
  }, {
    label: 'Fit',
    id: 'fit'
  }, {
    label: 'Contact',
    id: 'contact'
  }];
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        menuButtonRef.current?.focus();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMobileMenuOpen]);
  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMobileMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node) && !menuButtonRef.current?.contains(e.target as Node)) {
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);
  // Focus management
  useEffect(() => {
    if (isMobileMenuOpen && menuRef.current) {
      const firstButton = menuRef.current.querySelector('button');
      firstButton?.focus();
    }
  }, [isMobileMenuOpen]);
  return <>
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50" data-id="element-111">
        <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-112">
          <button onClick={() => scrollToSection('hero')} className="text-sm font-bold tracking-widest uppercase text-black hover:text-gray-600 transition-colors" data-id="element-113">
            Brittney Gwynn
          </button>

          <nav className="hidden md:flex space-x-8" data-id="element-114">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-xs font-medium uppercase tracking-widest text-gray-500 hover:text-black transition-colors" data-id="element-115">
                {item.label}
              </button>)}
          </nav>

          <button ref={menuButtonRef} onClick={() => setIsMobileMenuOpen(true)} className="md:hidden text-xs font-medium uppercase tracking-widest text-black" aria-expanded={isMobileMenuOpen} aria-controls="mobile-menu" aria-label="Open navigation menu" data-id="element-116">
            Menu
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black/20 z-50 md:hidden" aria-hidden="true" data-id="element-117" />}

      {/* Mobile Menu Drawer */}
      <div ref={menuRef} id="mobile-menu" className={`fixed top-0 right-0 bottom-0 w-80 max-w-[85vw] bg-white shadow-2xl z-50 md:hidden transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} aria-label="Mobile navigation" data-id="element-118">
        <div className="flex flex-col h-full" data-id="element-119">
          {/* Header */}
          <div className="flex items-center justify-between px-6 h-20 border-b border-gray-200" data-id="element-120">
            <span className="text-sm font-bold tracking-widest uppercase text-black" data-id="element-121">
              Menu
            </span>
            <button onClick={() => {
            setIsMobileMenuOpen(false);
            menuButtonRef.current?.focus();
          }} className="text-gray-500 hover:text-black transition-colors p-2" aria-label="Close navigation menu" data-id="element-122">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-123">
                <path d="M5 5L15 15M5 15L15 5" data-id="element-124" />
              </svg>
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 px-6 py-8" data-id="element-125">
            <ul className="space-y-6" data-id="element-126">
              {navItems.map(item => <li key={item.id} data-id="element-127">
                  <button onClick={() => scrollToSection(item.id)} className="text-lg font-medium uppercase tracking-widest text-gray-600 hover:text-black transition-colors w-full text-left" data-id="element-128">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </nav>
        </div>
      </div>
    </>;
}